import { createRoot } from 'react-dom/client';
import App from './App';
import './index.css';

const root = document.getElementById('root');
if (!root) throw new Error('#root not found');

// No StrictMode: the neuro UI animates via imperative DOM appends + GSAP tweens,
// which StrictMode's dev-only simulated remount would double-run / desync.
createRoot(root).render(<App />);
